import { Icon } from '@scalis/components'
import { iconButtonClassName } from '../../icon/icon.styles'
import { HamburgerMenuButtonProps } from './hamburger-menu-button.types'

export const HamburgerMenuButton = ({ onClick, ...props }: HamburgerMenuButtonProps) => {
  return (
    <button
      type='button'
      onClick={onClick}
      aria-label={props['aria-label'] ?? 'hamburger menu button'}
      className={iconButtonClassName}
    >
      <Icon className='fa-solid fa-bars text-[20px]' />
    </button>
  )
}
